import P from 'bluebird';

window.Promise = P;

// window.Promise.longStackTraces();



// WEBPACK FOOTER //
// ./src/client/utils/global_util.js